import { DynamicForm } from '../common/components/DynamicForm';
import { Helper } from '../common/helpers/Helper';
import { StyleSheet, css } from 'aphrodite';
import React, { Component } from 'react';
import { AppButton } from '../common/components/AppButton';

export class CustomDynamicForm extends DynamicForm {
  generateActions() {
    let buttonText = 'Delete'
    let buttonStyle = Styles.buttonDelete
    if (Helper.inArray(['add', 'edit'], this.props.formDefinition.formType)) {
      buttonText = 'Save'
      buttonStyle = Styles.button
    } else if ('approve' === this.props.formDefinition.formType) {
      buttonText = 'Approve'
      buttonStyle = Styles.button
    }
    const dialogAction = <div className={css(Styles.actions)}>
      <span className={this.state.success ? css(Styles.successMsg) : css(Styles.errorMsg)}>
        {this.state.message}
      </span>
      {(this.props.formDefinition.formType === 'del' || this.props.formDefinition.formType === 'delete') &&
        this.generateDeleteField()
      }
      {this.props.showPreview && <div className={css(Styles.previewButtonContainer)}>
        <AppButton
          buttonStyle={buttonStyle}
          disabled={this.state.inProcess}
          onClick={this.showPreview.bind(this)}
          buttonText={'Preview'}
        />
      </div>}
      <AppButton
        buttonStyle={buttonStyle}
        disabled={this.state.inProcess}
        inProcess={this.state.inProcess}
        onClick={this.doAction}
        buttonText={buttonText}
      />
    </div>
    return dialogAction
  }

  doAction() {
    this.setState({
      inProcess: true, // Nothing should change while sumitting
      message: ''
    });

    const apiData = this.processValuesBeforeAction()
    if (!apiData) return
    if (apiData.iType === 'UPLOAD' && apiData.displayAdType === 'VIDEO') {
      apiData.adImageName = apiData.adVideoName
      delete apiData.adVideoName
      delete apiData.displayAdType
    }

    // If validation is successful, get the htmlContent also
    const formValues = this.getFormValues()
    if (this.props.getPreview) {
      const htmlContent = this.props.getPreview(formValues)
      apiData.adHtml = htmlContent
    }
    this.submit(apiData)
  }

  showPreview() {
    const validationSuccess = this.validateOnPreview()
    if (!validationSuccess) {
      return
    }
    const formValues = this.getFormValues()
    if (this.props.showPreview && this.props.getPreview) {
      const htmlContent = this.props.getPreview(formValues)
      this.props.showPreview(htmlContent)
    }
  }

  getFormValues() {
    const formValues = {}
    this.fields = this.props.formDefinition.steps[0].fields;
    console.log('this.fields::', this.fields)
    for (const current of this.fields) {
      formValues[current.key] = this.state[current.key]
      if (current.key === 'logoName' || current.key === 'heroImageName') {
        formValues[current.key] = current.link
      }
    }
    return formValues
  }

  validateOnPreview() {
    this.setState({
      success: true,
      message: null,
    });
    let errMsg, validationSuccess = true
    for (const current of this.fields) {
      if (current.key === 'text' || current.key === 'subtext') {
        if (current.v_max.value && this.state[current.key] && (this.state[current.key].length > current.v_max.value)) {
          errMsg = current.v_max.err
          validationSuccess = false
          break
        }
        if (current.v_min.value && this.state[current.key] && (this.state[current.key].length < current.v_min.value)) {
          errMsg = current.v_min.err
          validationSuccess = false
          break
        }
      }
      if (current.key === 'heroImageName') {
        if (current.v_required.value && !this.state.heroImageName) {
          errMsg = current.v_required.err
          validationSuccess = false
          break
        }
      }
    }
    if (!validationSuccess) {
      this.setState({
        success: false,
        message: errMsg,
      });
    }
    return validationSuccess
  }
}

const Styles = StyleSheet.create({
  errorMsg: {
    paddingRight: 20,
    color: '#f44336'
  },
  successMsg: {
    paddingRight: 20,
    color: 'green'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 20,
    marginBottom: 30
  },

  buttonDelete: {
    backgroundColor: '#FF0D0D'
  },
  previewButtonContainer: {
    marginRight: 10
  },
})


// WEBPACK FOOTER //
// ./src/components/CustomDynamicForm.js